import Card from '../card/Card';
import P from '../texts/p/P';
import Icon from '../icon/Icon';
import Tooltip from '../tooltip/Tooltip';
import { useFiscalIdConfig } from '../../hooks/useFiscalIdConfig';

const MontoTooltipLabel = () => {
  const fiscalId = useFiscalIdConfig();
  const tooltipMsg =
    `El monto se valida contra dos límites simultáneos: (1) el disponible del producto ` +
    `aprobado para el ${fiscalId.label} en esta divisa, y (2) el disponible total del ${fiscalId.label} en la divisa ` +
    `de las líneas asociadas. El aval se acepta solo si pasa ambos.`;

  return (
    <Card display='flex' alignItems='center' gap='4px' style={{ whiteSpace: 'nowrap' }}>
      <P withMargin={false} variant='neutral' type='4' modifier='strong'>
        Monto bruto *
      </P>
      <Tooltip position='right' msg={tooltipMsg} showArrow>
        <Icon
          name='info_outline'
          variant='neutral'
          modifier='weak'
          width={14}
          height={14}
          cursor='pointer'
        />
      </Tooltip>
    </Card>
  );
};

export default MontoTooltipLabel;
